import { Checkbox } from '../Checkbox';

import { ExportMultipleItem } from './export_multiple_item';

import './styles.scss'

const Realize = {
  i18n: window.Realize.i18n,
};

export function ExportMultipleContent({
  data,
  errors,
  selectedDocuments,
  isAllDocumentsSelected,
  onToggleSelectedDocument,
  onToggleAllDocumentsSelected
}) {
  return (
    <div className='export-multiple-table-container'>
      <table className='table striped export-multiple-table'>
        <thead>
          <tr>
            <th style={{ width: '5%' }}>
              <div className='flex-center'>
                <Checkbox
                  isChecked={isAllDocumentsSelected}
                  onChange={() => onToggleAllDocumentsSelected()}
                />
              </div>
            </th>
            <th>{Realize.i18n.t('exportMultipleModal.file_name')}</th>
            <th style={{ width: '40%' }}>
              {Realize.i18n.t('exportMultipleModal.associated_fields')}
            </th>
            <th style={{ width: '5%' }}></th>
          </tr>
        </thead>
        <tbody>
          {data.map((document) => {
            const documentError = errors && errors.find(error => {
              return error.identification === document.fileUuid;
            })

            return (
              <ExportMultipleItem 
                key={document.fileUuid}
                document={document}
                error={documentError}
                isChecked={selectedDocuments.has(document.fileUuid)}
                onToggleSelectedDocument={onToggleSelectedDocument}
              />
            )
          })}
        </tbody>
      </table>
    </div>
  )
}